import { render, staticRenderFns } from "./LandUseAndLandCoverOverviewChart.vue?vue&type=template&id=680dfd49"
import script from "./LandUseAndLandCoverOverviewChart.vue?vue&type=script&lang=js"
export * from "./LandUseAndLandCoverOverviewChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports